import "./VSGroup.module.css";
import Header from "@/reusable_sections/Header";
import BusinessGrowthCatalyst from "./sections/BusinessGrowthCatalyst";
import OurCareSolutions from "./sections/OurCareSolutions";
import ApplicationAreas from "./sections/ApplicationAreas";
import TheNovaPathStory from "./sections/TheNovaPathStory";
import StrategicCapabilities from "./sections/StrategicCapabilities";
import RealEstate from "./sections/RealEstate";
import GlobalSkillsStatistics from "./sections/GlobalSkillsStatistics";
import TheConstructionJourney from "./sections/TheConstructionJourney";
import OperationalCompliance from "./sections/OperationalCompliance";
import AdministrativeIntegrity from "./sections/AdministrativeIntegrity";
import ConnectWithUs from "./sections/ConnectWithUs";
import Footer from "@/reusable_sections/Footer";
export default function VSGroupPage() {
  return <div>
      <Header />
      <BusinessGrowthCatalyst />
      <OurCareSolutions />
      <ApplicationAreas />
      <TheNovaPathStory />
      <StrategicCapabilities />
      <RealEstate />
      <GlobalSkillsStatistics />
      <TheConstructionJourney />
      <OperationalCompliance />
      <AdministrativeIntegrity />
      <ConnectWithUs />
      <Footer />
    </div>;
}